import * as VueRouter from 'vue-router'
import config from '@/utils/config'
//防止重复点击
const routes = [
    {
        path: config.indexURL,
        name: '',
        component: () =>
            import ("@/view/pageTop.vue"),
        children: [{
            path:'',
            name: '首页',
            component: () =>
                import ("@/view/index/index.vue"),
            },
            {
                path: "/dataStat",
                name: '数据统计',
                component: () =>
                    import ("@/view/dataStat/dataStat.vue"),
            },
            {
                path: "/algorithmMaintain",
                name: '算法维护',
                component: () =>
                    import ("@/view/algorithmMaintain/algorithmMaintain.vue"),
            },
            {
                path: "/accountManagement",
                name: '账号管理',
                component: () =>
                    import ("@/view/accountManagement/accountManagement.vue"),
            },
        ],
        meta: {
            requireAuth: false,
        }

    },
    {
        path: "/map",
        name: '地图页',
        component: () =>
            import ("@/view/map/map.vue"),
        meta: {
            requireAuth: false,
        }
    },
    {
        path: config.loginURL,
        name: '登录',
        component: () =>
            import ("@/view/login.vue"),
        meta: {
            requireAuth: false,
        }
    },
    {
        path: config.previewDocumentURL,
        name: '预览文档',
        component: () =>
            import ('@/view/preview/preview.vue'),
        meta: {
            requireAuth: false,
            title: '预览文档',
        }
    },
    // {
    //     path: config.updataURL,
    //     name: '修改终端号',
    //     component: () =>
    //         import ('@/view/updata/tool.vue'),
    //     meta: {
    //         requireAuth: false,
    //         title: '修改终端号',
    //     }
    // },
    {
        path: config.previewPhototURL,
        name: '预览终端安装布置图',
        component: () =>
            import ('@/view/photoPreview/photoPreview.vue'),
        meta: {
            requireAuth: false,
            title: '预览终端安装布置图',
        }
    }
]
const router = VueRouter.createRouter({
        history: VueRouter.createWebHistory(),
        routes,
    })
    //useRoute中存在push方法
const originalReplace = router.replace.prototype
router.replace.prototype = function replace(location) {
    return originalReplace.call(this, location).catch(err => err)
}

export default router